module.exports = __webpack_public_path__ + "img/DAILY-FRED-LOGO-JOSEPHINE_SANS_a9c4bb34-58aa-408c-b57e-75cc1749408c.png";